export enum SmevRequestActionEnum {
  SMEV_REQUEST_GET_DATA = 'SMEV_REQUEST_GET_DATA',
  SMEV_REQUEST_SET_DATA = 'SMEV_REQUEST_SET_DATA',
  SMEV_REQUEST_GET_COMMON_DATA = 'SMEV_REQUEST_GET_COMMON_DATA',
  SMEV_REQUEST_SET_REQUEST_TEMPLATES = 'SMEV_REQUEST_SET_REQUEST_TEMPLATES',
  SMEV_REQUEST_SET_REQUEST_TYPES = 'SMEV_REQUEST_SET_REQUEST_TYPES',
  SMEV_REQUEST_CREATE = 'SMEV_REQUEST_CREATE',
}
